<template>
   <div class="version"></div>
   <!-- <div class="version" :class="{ absolute }">v{{version}}</div> -->
</template>

<script>
import { version } from '../../package'

export default {
    name: 'Version',
    data () {
        return {
            version,
            absolute: false
        }
    },
    mounted () {
        const that = this
        const elm = document.body
        let lastHeight = elm.clientHeight
        let newHeight

        (function run () {
            newHeight = elm.clientHeight
            if (lastHeight !== newHeight) {
                const windowHeight = window.innerHeight
                that.absolute = newHeight < windowHeight
            }
            lastHeight = newHeight

            if (elm.onElementHeightChangeTimer) {
                clearTimeout(elm.onElementHeightChangeTimer)
            }
            elm.onElementHeightChangeTimer = setTimeout(run, 200)
        })()
    }
}
</script>

<style scoped lang="scss">
    .version {
        color: #ccc;
        text-align: center;
        font-size: 14px;
        margin-bottom: 16px;
        margin-top: 60px;

        &.absolute {
            width: 100%;
            position: fixed;
            bottom: 0;
        }
    }
</style>
